import { getNodeString, Value } from '@udecode/plate-common';

export const getEditorText = (nodes: Value) => {
  return nodes.map(node => getNodeString(node)).join('');
};
